






































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { constants } from 'http2';

@Component
export default class MobileNavigationDrawer extends Vue {
    @Prop({ default: false }) public show!: boolean;

    public beforeLoginNavigationList: any[] = [
        {
            key: 1,
            name: 'Login',
            path: '/login',
        },
        {
            key: 2,
            name: 'Register',
            path: '/register',
        },
    ];

    public afterLoginNavigationList: any[] = [
        {
            key: 1,
            name: 'Home',
            path: '/home',
        },
        {
            key: 2,
            name: 'Asset',
            path: '/asset',
        },
        {
            key: 3,
            name: 'Activity',
            path: '/activity',
        },
        {
            key: 4,
            name: 'Profile',
            path: '/Profile',
        },
        {
            key: 5,
            name: 'Logout',
            path: '/logout',
        },
    ];

    public updateShow(isShow: boolean) {
        this.$emit('update:show', isShow);
    }

    public onNavigationDrawerClick(path: string) {
      this.$emit('update:show', false);

      if (path === '/logout') {
        this.$store.commit('MUTATE_AUTH', {
            login: false,
        });
        this.$router.replace('/login');
      } else {
        this.$router.push(path);
      }
    }

    get isLogin() {
        return this.$store.getters.getAuth.login;
    }
}
